<template>
  <share-with-pulse-users-modal-content
    v-bind="$props"
    :period-private="!!periodPrivate"
    :shared-message="sharedMessage"
    :unshared-message="unsharedMessage"
    modal-id="share-workflow-with-pulse-users-modal"
  />
</template>

<script setup lang="ts">
import ShareWithPulseUsersModalContent from './share-with-pulse-users-modal-content.vue'
import { PulseShareType } from '../../shared/types/pulse-share'
interface Props {
  ledgerName: string
  ledgerId: number
  sharedObjectId: number
  title: string
  tooltip?: string | null
  isBlockedInitial?: boolean
  sharedObjectClass?: string
  shareType?: PulseShareType | null
  periodPrivate?: boolean
}

const I18n = window.I18n

defineOptions({ name: 'ShareWorkflowWithPulseUsersModal' })
defineProps<Props>()
const sharedMessage = (selectedUsersCount: number) =>
  I18n.t('pulse.sharing.number_of_pulse_users_access_workflow', {
    number: selectedUsersCount,
  })

const unsharedMessage = I18n.t('pulse.sharing.no_pulse_users_access_workflow')
</script>
